import { UTCDate } from '@date-fns/utc';
import { format } from 'date-fns';

// UTC-safe date formatter. The backend returns naked Postgres timestamps
// without a trailing `Z`; `new UTCDate(naked)` would parse them in the
// viewer's local timezone and drift the rendered value. We append `Z` when no
// timezone marker is present so the value is always interpreted as UTC
// wall-clock — per the project UTC rule — then format with date-fns.
//
// NOTE: this is the canonical parse path. Slice-local copies that parse with a
// raw `new Date(...)` (no UTC normalisation) are date-bug candidates, NOT
// drop-in replacements, and are intentionally left where they are.
const TIMEZONE_MARKER = /[zZ]$|[+-]\d{2}:?\d{2}$/;

export const formatUtcDate = (
  iso: string | null | undefined,
  pattern: string,
  fallback = '—'
): string => {
  if (!iso) return fallback;
  // Naked Postgres timestamps use a space separator ("2026-01-15 09:05:00");
  // switch it to `T` and append `Z` so the value is unambiguous ISO 8601 UTC
  // (space-separated strings are not spec-guaranteed to parse everywhere).
  const normalised = TIMEZONE_MARKER.test(iso)
    ? iso
    : `${iso.replace(' ', 'T')}Z`;
  const date = new UTCDate(normalised);
  if (Number.isNaN(date.getTime())) return fallback;
  return format(date, pattern);
};
